import type { SxProps, Theme } from '@mui/material';

export const illustrationContainer: SxProps<Theme> = {
  position: 'relative',
  width: '100%',
  height: '100%',
};

export const ellipseContainer = (
  bottom: string | number,
  left: string | number,
  right: string | number,
  top: string | number,
): SxProps<Theme> => ({
  position: 'absolute',
  bottom,
  left,
  right,
  top,
});

export const imageStyle: React.CSSProperties = {
  display: 'block',
  maxWidth: 'none',
  width: '100%',
  height: '100%',
};

export const maskGroupContainer = (mode: 'Light' | 'Dark'): SxProps<Theme> => ({
  position: 'absolute',
  bottom: '-7.113%',
  left: mode === 'Light' ? '15.434%' : '15.595%',
  right: '-12.219%',
  top: '-12.552%',
});

export const illustrationWrapper: SxProps<Theme> = {
  position: 'relative',
  width: 311,
  height: 239,
  overflow: 'hidden',
};

export const container: SxProps<Theme> = {
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'center',
  height: '100%',
  minHeight: 400,
  textAlign: 'center',
  gap: 3,
};

export const message: SxProps<Theme> = {
  fontWeight: 400,
  fontSize: '24px',
  lineHeight: 1.334,
};
